import { ActionService, DataStorageEnums, DataStorageQuery, Query, ReduxService, SymbolSearchQuery, SymbolSearchSortBy } from 'dashboard-services';
import { globalActions } from 'primary-components';

import getApiConfig from 'api/ApiConfig';
import properties from 'resources/constants/properties.json';
import { FormulaUtils, LocalStorageUtils, TimeSeriesUtils } from 'utils';

import { settingsSeriesActions } from './';

export default (() => {
  const FILTER_TYPE = {
    GROUP_NAME: "groupName",
    METADATA: DataStorageEnums.KEY_TYPE.METADATA,
    SYMBOL: DataStorageEnums.KEY_TYPE.SYMBOL
  }
  
  const ON_CHANGE = 'ON_CHANGE_CREATOR_SERIES'
  const onChange = ActionService.makeActionCreator(ON_CHANGE, 'value', 'name')

  const ON_CHANGE_SYMBOL_COLUMNS = 'ON_CHANGE_SYMBOL_COLUMNS_CREATOR_SERIES'
  const onChangeSymbolColumns = ActionService.makeActionCreator(ON_CHANGE_SYMBOL_COLUMNS, 'value', 'index')

  const ON_REMOVE_SYMBOL_COLUMNS = 'ON_REMOVE_SYMBOL_COLUMNS_CREATOR_SERIES'
  const onRemoveSymbolColumns = ActionService.makeActionCreator(ON_REMOVE_SYMBOL_COLUMNS, 'index')
  
  const ON_CHANGE_OBJECT = 'ON_CHANGE_OBJECT_CREATOR_SERIES'
  const onChangeObject = ActionService.makeActionCreator(ON_CHANGE_OBJECT, 'value', 'fieldName', 'name')
  

  const getIndexOfOneSymbolInBasket = (symbol, selectedSymbols) => selectedSymbols.findIndex(sel => JSON.stringify(sel.symbols) === JSON.stringify(symbol.symbols) && sel.groupName === symbol.groupName && sel.pattern === "false")
  const getIndexOfPatternSymbolInBasket = (symbol, selectedSymbols) => selectedSymbols.findIndex(sel => JSON.stringify(sel.symbols) === JSON.stringify(symbol.symbols) && sel.groupName === symbol.groupName && sel.query === symbol.query && JSON.stringify(sel.metadata) === JSON.stringify(symbol.metadata))

  const isMatchingQuery = ({ query, value = "" }) => value.match(query)
  const isMatchingQueryObj = ({ query, value = {} }) => Object.values(value).some(v => isMatchingQuery({ query, value: v }))

  const isInBasket = (symbol, selectedSymbols = []) => {
    const isDirectlySelected = selectedSymbols.findIndex(sel => {
      if(sel.pattern === "false") {
        return JSON.stringify(sel.symbols) === JSON.stringify(symbol.symbols) && sel.groupName === symbol.groupName 
      }
      return false;
    }) > -1
    const isPatternSelected = selectedSymbols.findIndex(sel => {
      if(sel.pattern !== "false") {
        if(sel.groupName !== symbol.groupName && sel.groupName) {
          return false;
        }
        const symbolMatch = !Object.entries(sel?.symbols || {}).some(([key, value]) => symbol.symbols[key] !== value && value !== "*");
        if(symbolMatch) {
          const metadataMatch = !Object.entries(sel?.metadata || {}).some(([key, value]) => symbol.metadata[key] !== value && value !== "*");
          if(metadataMatch) {
            if(sel.query) {
              const matchQuery = (isMatchingQuery({ query: sel.query, value: sel.groupName }) || isMatchingQueryObj({ query: sel.query, val: sel.symbols }) || isMatchingQueryObj({ query: sel.query, value: sel.metadata }))
              return matchQuery;
            }
            return true;
          }
        }
        return false;
      }
      return false;
    }) > -1

    return {
      isDirectlySelected,
      isPatternSelected
    }
  }

  const SWAP_SELECTED_SYMBOL = 'SWAP_SELECTED_SYMBOL_CREATOR_SERIEES'
  const swapSelectedSymbol = symbol => (dispatch, getState) => {
    if(symbol.pattern === "false") {
      const index = getIndexOfOneSymbolInBasket(symbol, getState().seriesState.creatorState.selectedSymbols)
      const localSymbol = ReduxService.updateObject(symbol, { pattern: "false" })
      if(index === -1) {
        LocalStorageUtils.addSymbolToRecents(localSymbol)
      }
      dispatch(swapSelectedSymbolReducer(localSymbol, index))
    } else {
      // only for removing
      const index = getIndexOfPatternSymbolInBasket(symbol, getState().seriesState.creatorState.selectedSymbols)
      if(index === -1) {
        return;
      }
      dispatch(swapSelectedSymbolReducer(symbol, index))
    }
  }
  const swapSelectedSymbolReducer = ActionService.makeActionCreator(SWAP_SELECTED_SYMBOL, 'symbol', 'index')

  const CLEAR = 'CLEAR_CREATOR_SERIES'
  const clear = ActionService.makeActionCreator(CLEAR)

  const getSortString = userDefinedFilters => {
    const builder = userDefinedFilters.reduce((prev, curr) => {
      if(curr) {
        if(curr.type === FILTER_TYPE.GROUP_NAME) {
          return prev
        }
        return curr.type === FILTER_TYPE.METADATA ? prev.withMetadataSort(curr.filterKey) : prev.withSort(curr.filterKey)
      }
      return prev;
    }, new SymbolSearchSortBy.Builder())
    return builder.withSort("Symbol").build().getSortBy()
  }

  const getSearchQuery = ({ query, groupName, symbolsFilter = {}, metadatasFilter = {} }) => {
    let builder = new SymbolSearchQuery.Builder()
      .withSymbols(Object.entries(symbolsFilter).map(([key, value]) => ({ key, value })))
      .withMetadatas(Object.entries(metadatasFilter).map(([key, value]) => ({ key, value })))
      .withQueryString(query ? `${query}*` : "")
    if(groupName) {
      builder = builder.withGroupName(`*${String(groupName).toLowerCase()}*`, false)
    }
    return builder
      .build()
      .getQuery()
  }

  const searchSymbols = async ({ query, symbolsFilter, metadatasFilter, groupFilter, userDefinedFilters, from = 0, columns = undefined, uniqueProviders }) => {
    if(!(query || Object.keys(metadatasFilter || {}).length > 0 || Object.keys(symbolsFilter).length > 0 || groupFilter)) {
      return Promise.resolve().then(() => ({ items: [], from: 0, totalSize: 0 }));
    }
    const buildedQuery = getSearchQuery({ query, symbolsFilter, metadatasFilter, groupName: groupFilter }),
          sortBy = getSortString(userDefinedFilters),
          getQueryBuilder = () => new Query.Builder(window["ngStore" + properties.functionsNamespace].dispatch(getApiConfig()))
            .withShouldDisplayError(false)
            .withHeader("Target", uniqueProviders[0], true),
          { queryFn } = DataStorageQuery.QUERIES.searchSymbols(getQueryBuilder, {
            query: buildedQuery,
            size: 100,
            sortBy,
            withValuesOnly: true
          })
    if(columns) {
      return await queryFn({
        signal: new AbortController().signal,
        pageParam: from,
      })
    }
    return await queryFn({
      signal: new AbortController().signal,
      pageParam: from,
    })
  }

  const areFiltersChanged = () => !!LocalStorageUtils.getSavedSeriesFilters()

  const getSymbolsFilter = ({ filters, userDefinedFilters }) => {
    const toReturn = {}
    const notMd = userDefinedFilters.filter(udf => udf.type === FILTER_TYPE.SYMBOL).filter(udf => filters[udf.filterKey] !== undefined)
    if(notMd.length === 0) {
      return undefined;
    }
    notMd.forEach(udf => toReturn[udf.filterKey] = filters[udf.filterKey])
    return toReturn
  }

  const getMetadatasFilter = ({ filters, userDefinedFilters }) => {
    const toReturn = {}
    const mds = userDefinedFilters.filter(udf => udf.type === FILTER_TYPE.METADATA).filter(udf => filters[udf.filterKey] !== undefined)
    if(mds.length === 0) {
      return undefined;
    }
    mds.forEach(udf => toReturn[udf.filterKey] = filters[udf.filterKey])
    return toReturn
  }

  const getGroupFilter = ({ filters, userDefinedFilters }) => {
    const groupName = userDefinedFilters.find(udf => udf.type === FILTER_TYPE.GROUP_NAME)
    return groupName ? filters[groupName.filterKey] : undefined
  }

  const createPattern = () => (dispatch, getState) => {
    const { query, filters = {}, userDefinedFilters = [] } = getState().seriesState.creatorState,
          source = getState().globalState.source
    const key = {
      query,
      symbols: getSymbolsFilter({ filters, userDefinedFilters }) || {},
      metadata: getMetadatasFilter({ filters, userDefinedFilters }) || {},
      groupName: getGroupFilter({ filters, userDefinedFilters }),
      pattern: "true",
      source,
    }
    dispatch(swapSelectedSymbolReducer(key, -1))
  }

  const ON_REORDER_ITEM = 'ON_REORDER_ITEM_CREATOR_SERIES'
  const onReorderItem = ActionService.makeActionCreator(ON_REORDER_ITEM, 'from', 'to', 'pattern')

  const getParams = () => (_, getState) => getState().seriesState.settingsState

  const editFormula = ({ params, keys, address }) => async (dispatch, getState) => {
    const userDefinedFilters = getState().seriesState.creatorState.userDefinedFilters
    dispatch(clear())
    dispatch(settingsSeriesActions.clear())
    const { uniqueProviders = [], defaultSource = undefined, shouldContinue } = await dispatch(FormulaUtils.validateProvidersForEdit({ keys, address }))
    if(!shouldContinue) {
      return;
    }
    dispatch(globalActions.onChange(uniqueProviders[0] || defaultSource, "source"))
    TimeSeriesUtils.PLAIN_PARSED_TS_PARAMS.filter(param => params[param] && params[param] !== "undefined").forEach(param => dispatch(settingsSeriesActions.onChange(params[param], param)))
    if(params.startDate === DataStorageEnums.DATE_BETWEEN_TYPE.TODAY) {
      dispatch(settingsSeriesActions.onChange(DataStorageEnums.DATE_BETWEEN_TYPE.TODAY, "fromSelected"))
      dispatch(settingsSeriesActions.onChange(undefined, "from"))
    } else if(params.startDate) {
      dispatch(settingsSeriesActions.onChange(DataStorageEnums.DATE_BETWEEN_TYPE.DATE, "fromSelected"))
      dispatch(settingsSeriesActions.onChange(String(params.startDate).split("T")[0], "from"))
    }
    if(params.endDate === DataStorageEnums.DATE_BETWEEN_TYPE.TODAY) {
      dispatch(settingsSeriesActions.onChange(DataStorageEnums.DATE_BETWEEN_TYPE.TODAY, "toSelected"))
      dispatch(settingsSeriesActions.onChange(undefined, "to"))
    } else if(params.endDate) {
      dispatch(settingsSeriesActions.onChange(DataStorageEnums.DATE_BETWEEN_TYPE.DATE, "toSelected"))
      dispatch(settingsSeriesActions.onChange(String(params.endDate).split("T")[0], "to"))
    }
    const selectedSymbolsPromises = []
    keys.forEach(key => {
      if(key.pattern === "true" || key.pattern === undefined) {
        key.metadata = key.metadatas
        delete key.metadatas
        selectedSymbolsPromises.push(Promise.resolve().then(() => key))
      } else {
        selectedSymbolsPromises.push(
          searchSymbols({ symbolsFilter: key.symbols, userDefinedFilters, withTerminate: false, uniqueProviders })
            .then(({ items = [] } = {}) => items?.[0] ? ReduxService.updateObject(items[0], { columns: key?.columns, source: key?.source || defaultSource, pattern: "false" }) : undefined)
        )
      }
    })
    Promise.all(selectedSymbolsPromises).then(items => {
      dispatch(onChange(items.filter(i => i !== undefined), "selectedSymbols"))
    }).catch(e => console.error(e))
    dispatch(onChange(address, "address"))
  }

  const PATTERN_MESSAGE = "To select individual data items you need to discard pattern selection. Do you want to proceed?"
  const PROVIDER_MESSAGE = "To select data from different provider you need to discard all your current selections. Do you want to continue?"

  const onAddRowWithToast = ({ addToBasket, symbol, message }) => dispatch => {
    dispatch(globalActions.getToastsStore()).warning(message, "Discard selection", {
      withCancel: false,
      confirmText: "Discard all",
      confirmAction: () => {
        dispatch(onChange([], "selectedSymbols"))
        addToBasket(symbol)
      }
    })
  }

  const onAddRow = ({ arePatternsSelected, addToBasket, selectedSymbols, source, symbol }) => dispatch => {
    if(arePatternsSelected) {
      dispatch(onAddRowWithToast({ addToBasket, symbol, message: PATTERN_MESSAGE }))
    } else if(selectedSymbols?.length > 0 && selectedSymbols[0]?.source !== source) {
      dispatch(onAddRowWithToast({ addToBasket, symbol, message: PROVIDER_MESSAGE }))
    } else {
      addToBasket(symbol)
    }
  }

  return {
    onChange,
    ON_CHANGE,
    onChangeSymbolColumns,
    ON_CHANGE_SYMBOL_COLUMNS,
    onRemoveSymbolColumns,
    ON_REMOVE_SYMBOL_COLUMNS,
    onChangeObject,
    ON_CHANGE_OBJECT,
    CLEAR,
    clear,
    getSearchQuery,
    searchSymbols,
    FILTER_TYPE,
    areFiltersChanged,
    SWAP_SELECTED_SYMBOL,
    swapSelectedSymbol,
    isInBasket,
    createPattern,
    getSymbolsFilter,
    getMetadatasFilter,
    getGroupFilter,
    ON_REORDER_ITEM,
    onReorderItem,
    getParams,
    editFormula,
    getSortString,
    onAddRow,
    PATTERN_MESSAGE,
    PROVIDER_MESSAGE,
  }
})()